import React, { useEffect } from 'react';
import { useIntl } from "@edx/frontend-platform/i18n";
import {
  FormAutosuggestOption,
  FormControlFeedback,
} from "@openedx/paragon";
import AuthFormAutosuggest from "./AuthFormAutosuggest";
import classNames from "classnames";
import PropTypes from "prop-types";
import messages from "../messages";

const REGIONS = [
    "ALBA",
    "ARAD",
    "ARGES",
    "BACAU",
    "BIHOR",
    "BISTRITA-NASAUD",
    "BOTOSANI",
    "BRAILA",
    "BRASOV",
    "BUCURESTI",
    "BUZAU",
    "CALARASI",
    "CARAS-SEVERIN",
    "CLUJ",
    "CONSTANTA",
    "COVASNA",
    "DAMBOVITA",
    "DOLJ",
    "GALATI",
    "GIURGIU",
    "GORJ",
    "HARGHITA",
    "HUNEDOARA",
    "IALOMITA",
    "IASI",
    "ILFOV",
    "MARAMURES",
    "MEHEDINTI",
    "MURES",
    "NEAMT",
    "OLT",
    "PRAHOVA",
    "SALAJ",
    "SATU MARE",
    "SIBIU",
    "SUCEAVA",
    "TELEORMAN",
    "TIMIS",
    "TULCEA",
    "VALCEA",
    "VASLUI",
    "VRANCEA"
]

const RegioinField = (props) => {
  const { formatMessage } = useIntl();
  const {
    onChangeHandler,
    handleErrorChange,
    selectedRegion,
    errorMessage,
    onFocusHandler,
    occupation,
  } = props;
  
    useEffect(() => {
      if (props.errorMessage === undefined){
        return
      }
      if (props.errorMessage !== "") {
        handleOnChange("");
      }
      
    }, [errorMessage]);
  
  const handleOnChange = (value) => {
    
    onChangeHandler({ target: { name: 'region', value: value } } );
  }
  return (
    <div className="mb-4">
      <AuthFormAutosuggest
        floatingLabel={
          `${occupation === 'teacher'
            ? formatMessage(messages["region_teacher"])
            : ['student', 'pupil'].includes(occupation)
            ? formatMessage(messages["region_student"])
            : formatMessage(messages["region"])
          } *`
        }
        aria-label="form autosuggest"
        name="region"
        value={selectedRegion}
        onFocus={(e) => onFocusHandler(e)}
        className={classNames({ "form-field-error": props.errorMessage })}
        onChange={(value) => handleOnChange(value)}
      >
        {REGIONS.map((region) => (
          <FormAutosuggestOption key={region} id={region}>
           {region}
          </FormAutosuggestOption>
        ))}
      </AuthFormAutosuggest>
      {props.errorMessage !== "" && (
        <FormControlFeedback
          key="error"
          className="form-text-size"
          hasIcon={false}
          feedback-for="occupation"
          type="invalid"
        >
          {props.errorMessage}
        </FormControlFeedback>
      )}
    </div>
  );
};

export default RegioinField;
